import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  content: {
    flexGrow: 1,
    display: "flex"
  },
  pageContent: {
    marginTop: 25
  },
  mainContent: {
    [theme.breakpoints.up("xs")]: {
      display: "flex"
    }
  }
}));
